export default "__VITE_ASSET__a5095271__"